import { absoluteUrl } from './head';

const PROFESSIONAL = '/executive-medical-office';
const PRIVATE = '/private-medical-office';

export const MEDICAL_OFFICE_ROUTES = [PROFESSIONAL, `/en${PROFESSIONAL}`, PRIVATE, `/en${PRIVATE}`];

const descriptions = [
  'Medizinische Orientierung, Zugang zu Fachpersonen und Koordination für die Geschäftsleitung, finanziert im Rahmen einer BGM-Partnerschaft. Kein Eingriff.',
  'Medical orientation, access to specialists and coordination for your executive team, paid by your company through a BGM partnership. Not a treatment.',
  'Für Privatpersonen und Familien in der Schweiz und im Ausland: Zweitmeinung, passende Fachpersonen und koordinierte Behandlung, hier oder zuhause.',
  'Independent guidance for private clients and families in Switzerland and abroad: a Swiss second opinion, the right specialist and coordinated care.',
];
const titles = [
  'Executive Medical Office für Unternehmen | Health Prime',
  'Executive Medical Office for Executives | Health Prime',
  'Behandlung in der Schweiz: Private Medical Office | Health Prime',
  'Private Medical Office: Treatment in Switzerland | Health Prime',
];

export function getMedicalOfficeRoute(path: string) {
  const route = path.split(/[?#]/)[0].replace(/\/+$/, '');
  const index = MEDICAL_OFFICE_ROUTES.indexOf(route);
  if (index < 0) return undefined;
  const language = route.startsWith('/en/') ? 'en' as const : 'de' as const;
  const service = route.endsWith(PROFESSIONAL) ? 'professional' as const : 'private' as const;
  const base = service === 'professional' ? PROFESSIONAL : PRIVATE;
  const english = language === 'en';
  return {
    route, language, service,
    languageTag: english ? 'en' : service === 'professional' ? 'de-CH' : 'de',
    pairedRoute: english ? base : `/en${base}`,
    label: service === 'professional' ? 'Executive Medical Office' : 'Private Medical Office',
    title: titles[index],
    description: descriptions[index],
    alternates: [
      { language: service === 'professional' ? 'de-CH' : 'de', href: absoluteUrl(base) },
      { language: service === 'professional' ? 'en-CH' : 'en', href: absoluteUrl(`/en${base}`) },
      { language: 'x-default', href: absoluteUrl(service === 'professional' ? base : `/en${base}`) },
    ],
  };
}
